export class SnapshotRecipeValidity {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "valid",
            "baseName": "valid",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "expiresAt",
            "baseName": "expiresAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "invalid",
            "baseName": "invalid",
            "type": "Array<SnapshotRecipeInvalidSnapshot>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotRecipeValidity.attributeTypeMap;
    }
    constructor() {
    }
}
